export default class ProvisionLeaseClause {
    id: number;
    invoiceableLookupId?: number;
    contractLookupId?: number;
    contractAddendumClauseId?: number;
    contractAdHocClauseId?: number;
    leaseAdHocClauseId?: number;
    clauseTypeId?: number;
    clauseType: string;
    response: string;
    value: string;
    language: string;
    useClientApproved: boolean;
    clauseName: string;
    obligationType: string;
    obligationDate: Date;
    frequency: number;
    frequencyPeriod: string;
    obligationEndDate: Date;
    shortDescription: string;
    note: string;
}


// WEBPACK FOOTER //
// ./src/models/ProvisionLeaseClause.ts